import { STATUS_LABELS, STATUS_TAG_COLORS } from "../../AllPage/constants/statusMeta"

// Dispute lifecycle -> antd Tag {color,label}, derived from the shared single source
// (statusMeta) so the detail pill matches the /recover/all table and the Activity
// stream exactly. Labels are passed through t() at render.
export const STATUS_TAG = Object.fromEntries(
  Object.keys(STATUS_LABELS).map((k) => [
    k,
    { color: STATUS_TAG_COLORS[k] || "default", label: STATUS_LABELS[k] }
  ])
)
